import { z } from 'zod';

import { accountInformationSchema } from './account-information';
import { createExecutionSchema, ExecutionToggles } from './execution';
import { createHedgingSchema, HedgingToggles } from './hedging';
import { portfolioSchema } from './portfolio';

export interface AllToggles extends ExecutionToggles, HedgingToggles {}

export const DEFAULT_TOGGLES: AllToggles = {
  includePerpetualSpread: false,
  includeVolSpread: false,
  includePerpetualFee: false,
  includeOptionsFee: false,
  whenExecutionWeekdays: false,
  whenExecutionAverageIn: false,
  optionsNotionalScaled: false,
  deltaThreshold: false,
  deltaThresholdUpper: false,
  deltaThresholdLower: false,
  deltaTarget: false,
};

export const createStrategySchema = (toggles: AllToggles) =>
  z.object({
    name: z.string().min(1, 'Strategy name is required'),
    accountInformation: accountInformationSchema,
    execution: createExecutionSchema(toggles),
    hedging: createHedgingSchema(toggles),
    portfolio: portfolioSchema,
    entryConditions: z.object({
      enabled: z.boolean(),
      category: z.string(),
      token: z.string(),
      instrument: z.string(),
      tenor: z.string(),
      comparison: z.string(),
      value: z.string(),
    }),
    exitConditions: z.object({
      enabled: z.boolean(),
      category: z.string(),
      structurePvMaxIntrinsic: z.string(),
      structurePvPremium: z.string(),
      instrumentPvBase: z.string(),
      timeValueBase: z.string(),
      instrumentDeltaBaseQuote: z.string(),
      strikeVol: z.string(),
      timeToExpiry: z.string(),
      spotMoveSinceInception: z.string(),
      absoluteSpotMoveSinceInception: z.string(),
    }),
    rollPositions: z.object({
      enabled: z.boolean(),
      rollCondition: z.string(),
      comparison: z.string(),
      value: z.string(),
      rollType: z.string(),
    }),
  });

export type StrategySchemaType = z.infer<ReturnType<typeof createStrategySchema>>;
